import script from "./CompanyDashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyDashboard.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyDashboard.vue?vue&type=style&index=0&id=1b1a41b3&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b1a41b3"]])

export default __exports__